









import { Component, Vue, Prop } from 'vue-property-decorator';
import IChildNewButton from './types';

@Component
export default class ChildNewButton extends Vue implements IChildNewButton {
  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  get btnText(): string {
    return this.disabled ? 'Запись<br>закрыта' : 'Пригласить<br>пользователя';
  }

  onClick(): void {
    this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/newchildbtn/ChildNewButton.vue